import request from '@/service/request';

export const GetProductList = ({
  productType,
}: {
  productType: TTypes;
  filterBy: string;
}) => {
  const params = productType === 'pd' ? 'motor' : productType;
  return request(`/v1/shaft/admin/class/ips/vn/${params}/plans`);
};
